module.exports = __webpack_public_path__ + "static/media/icon-home-tag3.e5276eca.png";